import { ConfirmationDialog, Paragraph } from "@hightouch/htui";

type Props = {
  count: number;
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

/** Asks before attachments come off a project or task. The attached work itself is left alone. */
export const RemoveAttachmentsDialog = ({
  count,
  isOpen,
  onClose,
  onConfirm,
}: Props) => {
  const noun = count === 1 ? "attachment" : "attachments";
  return (
    <ConfirmationDialog
      isOpen={isOpen}
      title={`Remove ${noun}`}
      confirmButtonText="Remove"
      variant="danger"
      onClose={onClose}
      onConfirm={onConfirm}
    >
      <Paragraph>
        {count === 1
          ? "This takes the attachment off the project or task. The original isn't deleted. This can't be undone."
          : `This takes these ${count} attachments off the project or task. The originals aren't deleted. This can't be undone.`}
      </Paragraph>
    </ConfirmationDialog>
  );
};
